module.exports = __webpack_public_path__ + "media/images/klarna-e8703985.svg";